import { ReactElement } from 'react';
import { ExportDataContainer } from '../../../../modules/projects/details/exportData/ExportData.container';

export const ProjectDetailsExportDataView = (): ReactElement => <ExportDataContainer />;
